import { createSlice } from '@reduxjs/toolkit';
import { handleRequestThunk } from '../../../handleRequestThunk';
import { getBrakesState } from '../../thunks/vehicleProThunks';
import { commonInitialState } from '../../../../../utils/common/commonInitialState';
import { clearVehicleProKey } from '../../thunkKeys/vehicleProThunksKeys';

const SLICE_NAME = 'brakesState';

export const brakesStateSlice = createSlice({
    name: SLICE_NAME,
    initialState: structuredClone(commonInitialState),
    reducers: {
        clearBrakesState(state) {
            state.data = [];
        },
    },
    extraReducers: (builder) => {
        handleRequestThunk({ builder, request: getBrakesState });
        builder.addCase(
            clearVehicleProKey,
            () => commonInitialState,
        );
    },
});

export const { clearBrakesState } = brakesStateSlice.actions;

export const brakesState = brakesStateSlice.reducer;
